<template>
  <v-flex v-if="passwordRules" class="passwordPolicyChecker" data-qa="passwordpolicychecker-flex-zdpd65">
    <!-- passwordPolicyChecker--background -->
    <v-card flat class="pa-2 pt-0" data-qa="passwordpolicychecker-card-3mpfn">
      <v-layout v-if="displayRules[0] && displayRules[0].length || displayRules[1] && displayRules[1].length" row wrap data-qa="passwordpolicychecker-layout-wnqgsb">
        <v-flex xs12 sm12 md12 lg12 xl12 data-qa="passwordpolicychecker-flex-70kjd">
          <div class="font-weight-bold pb-2" data-qa="passwordpolicychecker-div-mpkev">
            <font color="#757575">{{
              $t("login.resetPassword.passwordPolicyLabel")
            }}</font>
          </div>
        </v-flex>
        <v-flex v-for="(item, i) in displayRules[0]" :key="item.rule" xs12 sm6 md6 lg6 xl6 :data-qa="`passwordpolicychecker-flex-2j0v8-${i}`">
          <v-row v-if="displayRules[0] && displayRules[0].length" no-gutters :data-qa="`passwordpolicychecker-row-khiyb9-${i}`">
            <v-flex xs2 sm2 md2 lg2 xl2 :data-qa="`passwordpolicychecker-flex-29zs4-${i}`">
              <v-icon
                :color="item.checked ? 'green' : ''"
                right
                small
                :data-qa="`passwordpolicychecker-icon-b5akyo-${i}`">{{ getIcon(item.checked) }}</v-icon
              >
            </v-flex>
            <v-flex xs9 sm9 md9 lg9 xl9 :data-qa="`passwordpolicychecker-flex-z6mja-${i}`">
              <span :class="{ 'passwordPolicyChecker--checked': item.checked }" :data-qa="`passwordpolicychecker-span-5uhxki-${i}`">
                {{ item.rule }}
              </span>
            </v-flex>
          </v-row>
        </v-flex>
        <v-flex v-for="(item, i) in displayRules[1]" :key="item.rule" xs12 sm6 md6 lg6 xl6 :data-qa="`passwordpolicychecker-flex-2j1v8-${i}`">
          <v-row v-if="displayRules[1] && displayRules[1].length" no-gutters :data-qa="`passwordpolicychecker-row-jv8irn-${i}`">
            <v-flex xs2 sm2 md2 lg2 xl2 :data-qa="`passwordpolicychecker-flex-nb4e5c-${i}`">
              <v-icon
                :color="item.checked ? 'green' : ''"
                right
                small
                :data-qa="`passwordpolicychecker-icon-2vninu-${i}`">{{ getIcon(item.checked) }}</v-icon
              >
            </v-flex>
            <v-flex xs9 sm9 md9 lg9 xl9 :data-qa="`passwordpolicychecker-flex-l2pvsx-${i}`">
              <span :class="{ 'passwordPolicyChecker--checked': item.checked }" :data-qa="`passwordpolicychecker-span-qe8l8-${i}`">
                {{ item.rule }}
              </span>
            </v-flex>
          </v-row>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import '@/styles/components/passwordPolicyChecker.scss'
import policies from '@/../mocks/passwordPolicies.json'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import _ from 'lodash'

export default {
  name: 'PasswordPolicyChecker',
  props: {
    config: String
  },
  data () {
    return {
      policies,
      passwordRules: [],
      passwordRegex: '',
      displayRules: [],
      passwordMinLength: this.$appSettings.defaultConfigurations.loginPageScreens.passwordMinLength
    }
  },
  async created () {
    await this.setPasswordRules()
    event.$on('PASSWORD_UPDATE', (data) => {
      if (data.new && data.new.trim().length) {
        this.checkPasswordStrength(data.new)
      } else if (!data.new || data.new.trim().length <= 0) {
        this.passwordRules.forEach((v) => { v.checked = false })
      }
      const checked = this.passwordRules.every((v) => v.checked === true)
      const policyCheckData = {
        ...data,
        checked: checked
      }
      if (checked) {
        event.$emit('POLICY_CHECK', policyCheckData)
      } else {
        event.$emit('POLICY_CHECK', { disableNext: true })
      }
    })
    event.$on('resetPasswordPolicies', () => {
      this.passwordRules.forEach((v) => { v.checked = false })
      this.setRulesArray()
    })
  },
  methods: {
    getIcon (item) {
      return item ? 'mdi-check' : 'mdi-close'
    },
    async setPasswordRules () {
      this.passwordRules =
        store.getters['profileStore/profileData'].passwordRules
      this.passwordRegEx =
        store.getters['profileStore/profileData'].passwordRegEx
      this.passwordRules && this.passwordRegEx ? this.setRulesArray() : await this.getPasswordRules()
    },
    async getPasswordRules () {
      if (this.$appSettings.authConfigurations.enableB2C) {
        await preload.getPasswordComplexity()
        const regEx = store.getters['profileStore/profileData'].passwordRegEx
        if (regEx) {
          this.passwordRules =
            store.getters['profileStore/profileData'].passwordRules
          this.passwordRegEx = regEx
          this.setRulesArray()
        }
      } else {
        this.passwordRegEx = this.policies.regex
        this.passwordRules = this.policies.rules
        this.setRulesArray()
      }
    },
    setRulesArray () {
      this.displayRules = _.chunk(this.passwordRules, 3)
    },
    checkPasswordStrength (str) {
      // TODO - Regex to be picked up by API response
      this.passwordRules.map((val) => {
        const uppercase = new RegExp('^(?=(.*[A-Z]){' + 1 + '})')
        const lowercase = new RegExp('^(?=(.*[a-z]){' + 1 + '})')
        const number = new RegExp('^(?=(.*\\d){' + 1 + '})')
        const specialChar = new RegExp('^(?=(.*[@$!%*?&]){' + 1 + '})')
        const minLength = new RegExp(`^.{${this.passwordMinLength},}$`)

        // Validate uppercase letter
        if (val.rule.includes('uppercase')) {
          if (uppercase.test(str)) {
            val.checked = true
          } else {
            val.checked = false
          }
        }
        // Validate lowercase letter
        if (val.rule.includes('lowercase')) {
          if (lowercase.test(str)) {
            val.checked = true
          } else {
            val.checked = false
          }
        }
        // Validate numbers
        if (val.rule.includes('digit') || val.rule.includes('number')) {
          if (number.test(str)) {
            val.checked = true
          } else {
            val.checked = false
          }
        }
        // Validate special characters
        if (val.rule.includes('special')) {
          if (specialChar.test(str)) {
            val.checked = true
          } else {
            val.checked = false
          }
        }
        // Validate minimum characters
        if (val.rule.includes('Minimum')) {
          if (minLength.test(str)) {
            val.checked = true
          } else {
            val.checked = false
          }
        }
        // Validate not identical
        if (val.rule.includes('identical')) {
          if (minLength.test(str)) {
            val.checked = true
          } else {
            val.checked = false
          }
        }
      })
    }
  }
}
</script>
